import { render, staticRenderFns } from "./Venture.vue?vue&type=template&id=8480d69e&"
import script from "./Venture.vue?vue&type=script&lang=js&"
export * from "./Venture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports